<template>
  <div>
    <cangchu-rk />
  </div>
</template>

<script>
// 获取接口地址
import CangchuRk from '@/components/ccManage/ccrk/cangchuRk.vue'

export default {
  name: 'Ccrk',
  components: {
    // sideMenu,
    // Header,
    CangchuRk
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
